<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                v-model="checked"
                :messages="toggleMessages"
                @input="onInput"
            />

            <div v-show="checked" class="option__multi">
                <span class="option__multi-label">
                    Field
                </span>

                <div class="option__input">
                    <dropdown
                        v-model="selectedField"
                        native
                        :options="fields"
                        @input="onInputField"
                    />
                </div>
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { SHOW_ALERT } from '@/store/types/mutation-types';
import * as service from '@/sitecore/sitecore-data-service';
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'control-data-dynamic',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Use Context Item as a Data Source',
            referenceData: {},
            fields: [],
            checked: true,
            toggleMessages: {
                checked: 'On',
                unchecked: 'Off',
            },
            useContextNew: false,
            selectedField: '',
        };
    },

    computed: {
        ...mapState({
            pageData: state => state.page.pageData,
            selectedElement: state => state.page.selectedElements.filter(e => e.isSelected)[0],
        }),
    },

    created() {
        this.getFields();
    },

    methods: {
        ...mapMutations({
            showAlert: SHOW_ALERT,
        }),

        onInputField(val) {
            this.setChangedData(true);
            this.selectedElement.linkedValueFieldNew = val;
            this.$root.$emit('flex::option::data-dynamic');
        },

        onInput(isChecked) {
            this.selectedElement.useContextNew = isChecked;
            this.$root.$emit('flex::option::data-dynamic');
            this.setChangedData(true);
        },

        onSelectedElement() {
            this.checked = this.selectedElement.useContextNew;
            this.selectedField = this.selectedElement.linkedValueFieldNew;
        },

        async getFields() {
            let fieldType = '';

            if (this.selectedElement.$attrs.dynamicProps) {
                if (this.selectedElement.$attrs.dynamicProps.includes('image')) {
                    fieldType = 'ImageField';
                } else if (this.selectedElement.$attrs.dynamicProps.includes('link')) {
                    fieldType = 'LinkField';
                } else {
                    fieldType = 'StringField';
                }
            } else {
                fieldType = 'LinkField';
            }

            const response = await service.getAvailableFields(this.pageData.pageData.id, fieldType);
            if (response.status === service.ERROR) {
                this.showAlert({ description: response.error });
                return;
            }
            this.fields = response.data.map(fld => ({ text: fld.name, value: fld.fieldId }));
        },
    },
};
</script>
